export default {
    cn: {
        accountSetting: {
            title: '账号设定',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            nodata: "没有查询到数据",
            status_text: '状态：',
            search: '搜索',
            undo: '重新绑定',
            do: '解除绑定',
            doConfirm: '确认解绑',
            undoConfirm: '确认重绑',
            three: '设置下次计算日期',
            threeConfirm: '确认下次计算日期',
            commit: '您真的要确认吗？',
            confirmation: '请您选择日期再设置下次计算日期',
            status_mapper: { "-1": "所有", "0": "生效中", "1": "已解绑" },
            result_mapper: { "0": "已计算", "1": "未能分成" },
            code_mapping: { '9000': '添加账户成功', '9001': '添加失败，账户已经存在', '9002': '添加失败，无效的账户' },
            message_type: { '9000': 'success', '9001': 'warning', '9002': 'warning' },
            enable_mapping: { 'ALL': '全部', 'Y': '启用', 'N': '禁用' },
            dialog_title: '日期设置',
            date_placeholder: '请选择日期',
            cancel: '取 消',
            ensure: '确 定',
            downloadExcelForms: "下载 Excel",
            calculate: '计算分成',
            addUser: '新增账户',
            confirm: '您确定要开始计算分成吗？',
            calculateDone: '计算已完成',
            noNeedCal: '没有需要计算的分成',
            required: '您需要选择日期才能确定',
            add_title: '新增账户',
            login: '账号',
            ib_account: '代理账号',
            percentage: '百分比',
            app_date: '申请日期',
            moreSelect: '显示更多筛选',
            deposit: '入金：',
            withdrawal: '出金：',
            transfer: '转账：',
            selectArr: [
                { label: '账号', value: 'LOGIN' },
                { label: '代理账号', value: 'IB_ID' },
            ],
            rules: {
                login: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (isNaN(value)) callback(new Error('请输入数字值'));
                            else callback();
                        },
                        trigger: 'blur'
                    }
                ],
                ib: [
                    { required: true, message: '请输入代理账号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (isNaN(value)) callback(new Error('请输入数字值'));
                            else callback();
                        },
                        trigger: 'blur'
                    }
                ],
                percentage: [
                    { required: true, message: '请输入百分比', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            const message = isNaN(value) ? '请输入数字值' : (value >= 1 || value <= 0 ? '百分比只能在0到1之间' : '');
                            message ? callback(new Error(message)) : callback();
                        },
                        trigger: 'blur'
                    }
                ],
                date: [
                    { type: 'date', required: true, message: '请选择申请日期', trigger: 'blur' }
                ]
            },
            first_row: [
                { key: 'LOGIN', name: '账号' },
                { key: 'GROUP', name: '组别' },
                { key: 'IB_ID', name: '代理账号' },
                { key: 'PERCENTAGE', name: '百分比' },
                { key: 'APPLICATION_DATE', name: '申请日期' },
                { key: 'DISCONNECT_DATE', name: '解绑日期' },
                { key: 'deposit', name: '入金' },
                { key: 'withdrawal', name: '出金' },
                { key: 'fundtransfer', name: '转账' },
                { key: 'LAST_CALC_START_DATE', name: '最后计算开始日期' },
                { key: 'LAST_CALC_END_DATE', name: '最后计算结束日期' },
                { key: 'NEXT_CALC_DATE', name: '下次计算日期' },
                { key: 'is_negative_before', name: '上次结果' },
                { key: 'is_deleted', name: '状态' },
                { key: 'UPDATE_BY', name: '最后更新' },
                { key: 'LAST_UPDATE', name: '更新时间', changeTime: true }
            ]
        }
    },
    hk: {
        accountSetting: {
            title: '賬號設定',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            nodata: "沒有查詢到數據",
            status_text: '狀態：',
            search: '搜索',
            undo: '重新綁定',
            do: '解除綁定',
            doConfirm: '確認解綁',
            undoConfirm: '確認重綁',
            three: '設置下次計算日期',
            threeConfirm: '確認下次計算日期',
            commit: '您真的要確認嗎？',
            confirmation: '请您选择日期再设置下次计算日期',
            status_mapper: { "-1": "所有", "0": "生效中", "1": "已解綁" },
            result_mapper: { "0": "已計算", "1": "未能分成" },
            code_mapping: { '9000': '添加賬戶成功', '9001': '添加失敗，賬戶已經存在', '9002': '添加失敗，無效的賬戶' },
            message_type: { '9000': 'success', '9001': 'warning', '9002': 'warning' },
            enable_mapping: { 'ALL': '全部', 'Y': '啟用', 'N': '禁用' },
            dialog_title: '日期設置',
            date_placeholder: '請選擇日期',
            cancel: '取 消',
            ensure: '確 定',
            downloadExcelForms: "下載 Excel",
            calculate: '計算分成',
            addUser: '新增賬戶',
            confirm: '您確定要開始計算分成嗎？',
            calculateDone: '計算已完成',
            noNeedCal: '沒有需要計算的分成',
            required: '您需要選擇日期才能確定',
            add_title: '新增賬戶',
            login: '賬號',
            ib_account: '代理賬號',
            percentage: '百分比',
            app_date: '申請日期',
            moreSelect: '顯示更多篩選',
            deposit: '入金：',
            withdrawal: '出金：',
            transfer: '轉賬：',
            selectArr: [
                { label: '賬號', value: 'LOGIN' },
                { label: '代理賬號', value: 'IB_ID' },
            ],
            rules: {
                login: [
                    { required: true, message: '請輸入賬號', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (isNaN(value)) callback(new Error('請輸入數字值'));
                            else callback();
                        },
                        trigger: 'blur'
                    }
                ],
                ib: [
                    { required: true, message: '請輸入代理賬號', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (isNaN(value)) callback(new Error('請輸入數字值'));
                            else callback();
                        },
                        trigger: 'blur'
                    }
                ],
                percentage: [
                    { required: true, message: '請輸入百分比', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            const message = isNaN(value) ? '請輸入數字值' : (value >= 1 || value <= 0 ? '百分比只能在0到1之間' : '');
                            message ? callback(new Error(message)) : callback();
                        },
                        trigger: 'blur'
                    }
                ],
                date: [
                    { type: 'date', required: true, message: '請選擇申請日期', trigger: 'blur' }
                ]
            },
            first_row: [
                { key: 'LOGIN', name: '賬號' },
                { key: 'GROUP', name: '組別' },
                { key: 'IB_ID', name: '代理賬號' },
                { key: 'PERCENTAGE', name: '百分比' },
                { key: 'APPLICATION_DATE', name: '申請日期' },
                { key: 'DISCONNECT_DATE', name: '解綁日期' },
                { key: 'deposit', name: '入金' },
                { key: 'withdrawal', name: '出金' },
                { key: 'fundtransfer', name: '轉賬' },
                { key: 'LAST_CALC_START_DATE', name: '最後計算開始日期' },
                { key: 'LAST_CALC_END_DATE', name: '最後計算結束日期' },
                { key: 'NEXT_CALC_DATE', name: '下次計算日期' },
                { key: 'is_negative_before', name: '上次結果' },
                { key: 'is_deleted', name: '狀態' },
                { key: 'UPDATE_BY', name: '最後更新' },
                { key: 'LAST_UPDATE', name: '更新時間', changeTime: true }
            ]
        }
    },
    en: {
        accountSetting: {
            title: 'Account Setting',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            nodata: "No data found",
            status_text: 'Status：',
            search: 'Search',
            undo: 'Rebind',
            do: 'Unbind',
            doConfirm: 'Confirm Unbind',
            undoConfirm: 'Confirm Rebind',
            three: 'Set Next Calculate Date',
            threeConfirm: 'Comfirm Next Calculate Date',
            commit: 'Do you really want to confirm?',
            status_mapper: { "-1": "All", "0": "Active", "1": "Deleted" },
            result_mapper: { "0": "Calculated", "1": "No Share" },
            code_mapping: { '9000': 'Add account successful', '9001': 'Add failed, account already exists', '9002': 'Add failed, invalid login' },
            message_type: { '9000': 'success', '9001': 'warning', '9002': 'warning' },
            enable_mapping: { 'ALL': 'All', 'Y': 'Enable', 'N': 'Disable' },
            dialog_title: 'Date Setting',
            date_placeholder: 'Select Date',
            cancel: 'Cancel',
            ensure: 'Ensure',
            downloadExcelForms: "Download Excel",
            calculate: 'Calculate',
            addUser: 'Add User',
            confirm: 'Are you sure start calculating the share?',
            calculateDone: 'Calculate complete',
            noNeedCal: 'No datas need to calculate',
            required: 'You need to select a date to ensure',
            login: 'Login',
            ib_account: 'IB Account',
            percentage: 'Percentage',
            app_date: 'Applicaton Date',
            moreSelect: 'Show More Select',
            deposit: 'Deposit：',
            withdrawal: 'Withdrawal：',
            transfer: 'Transfer：',
            selectArr: [
                { label: 'Login', value: 'LOGIN' },
                { label: 'IB Account', value: 'IB_ID' },
            ],
            rules: {
                login: [
                    { required: true, message: 'Please input login', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (isNaN(value)) callback(new Error('Please input number'));
                            else callback();
                        },
                        trigger: 'blur'
                    }
                ],
                ib: [
                    { required: true, message: 'Please input ib account', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (isNaN(value)) callback(new Error('Please input number'));
                            else callback();
                        },
                        trigger: 'blur'
                    }
                ],
                percentage: [
                    { required: true, message: 'Please input percentage', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            const message = isNaN(value) ? 'Please input number' : (value >= 1 || value <= 0 ? 'Percentage must be between 0 and 1' : '');
                            message ? callback(new Error(message)) : callback();
                        },
                        trigger: 'blur'
                    }
                ],
                date: [
                    { type: 'date', required: true, message: 'Please select application date', trigger: 'blur' }
                ]
            },
            first_row: [
                { key: 'LOGIN', name: 'Login' },
                { key: 'GROUP', name: 'Group' },
                { key: 'IB_ID', name: 'IB Account' },
                { key: 'PERCENTAGE', name: 'Percentage' },
                { key: 'APPLICATION_DATE', name: 'Applicaton Date' },
                { key: 'DISCONNECT_DATE', name: 'Disconnect Date' },
                { key: 'deposit', name: 'Deposit' },
                { key: 'withdrawal', name: 'Withdrawal' },
                { key: 'fundtransfer', name: 'Transfer' },
                { key: 'LAST_CALC_START_DATE', name: 'Last Start Date' },
                { key: 'LAST_CALC_END_DATE', name: 'Last End Date' },
                { key: 'NEXT_CALC_DATE', name: 'Next Date' },
                { key: 'is_negative_before', name: 'Last Result' },
                { key: 'is_deleted', name: 'Status' },
                { key: 'UPDATE_BY', name: 'Update By' },
                { key: 'LAST_UPDATE', name: 'Last Update', changeTime: true }
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/ProfitShareSetting/accountSetting.js